import React, { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { Checkbox, Divider, List } from 'react-native-paper'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { routes } from '../../../../../models'
import RootStore, { useStore } from '../../../store'
import { BButton } from '../../../ui/atoms/builder-2.0/Button'
import BuilderBottomModal from '../../../ui/molecules/BuilderBottomModal'
import { paths } from '../../links'
import { reasons } from '@linqpal/models/src/dictionaries'
import SignInStore from '../../Auth/stores/SignInStore'
import { useResponsive } from '../../../utils/hooks'

export const ReasonModal = ({
  modal = false,
  setModal,
  invoices,
  navigation,
}: {
  modal: boolean
  setModal: (val: boolean) => void
  invoices: any[] | any
  navigation: any
}) => {
  const { t } = useTranslation('global')
  const store = useStore()
  const { notificationStore, updateScreenMenuTop } = store.screensStore
  const [selectedReasons, setSelected] = useState<Array<string>>([])
  const { screenWidth } = useResponsive()
  const titleStyle = useMemo(
    () => ({
      fontSize: screenWidth < 360 ? 13 : 16,
    }),
    [screenWidth],
  )

  const isMultipleInvoice = Array.isArray(invoices)
  const invoice = isMultipleInvoice ? invoices[0] : invoices
  const invoiceId = isMultipleInvoice
    ? invoices.map((i) => i._id)
    : invoices._id

  const dismiss = () => {
    routes.invoices
      .dismiss({ id: invoiceId, dismiss_reasons: selectedReasons })
      .then(() => {
        setModal(false)
        if (!store.userStore.user) {
          if (invoice?.existingCustomer) {
            SignInStore.setLogin(invoice.existingCustomer.login)
            navigation.replace(paths.Auth._self, {
              params: { screen: paths.Auth.SignIn },
            })
          } else {
            navigation.replace(paths.Auth._self, {
              params: { screen: paths.Auth.SignUpHome },
            })
          }
        } else {
          if (navigation.canGoBack()) {
            navigation.goBack()
            RootStore.initRouteParams({ action: 'reloadInvoices' })
          } else {
            updateScreenMenuTop(false)
            notificationStore.fetchNotifications()
            navigation.replace(paths.Home._self, {
              screen: paths.Console.Payables._self,
              params: { screen: paths.Console.Payables.home },
            })
          }
        }
      })
  }
  return (
    <BuilderBottomModal
      visible={modal}
      height="80%"
      title={t('InvoiceDetails.tell-us-why-you-want-to-cancel')}
      onClose={() => {
        setModal(false)
      }}
    >
      {reasons.map((reason, i) => {
        const isChecked = selectedReasons.includes(reason)

        const onPress = () => {
          if (!isChecked) setSelected([...selectedReasons, reason])
          else
            setSelected([...selectedReasons.filter((item) => item !== reason)])
        }
        return (
          <TouchableOpacity key={i} onPress={onPress}>
            <View style={styles.itemContainer}>
              <List.Item key={i} title={reason} titleStyle={titleStyle} />
              <View style={styles.checkBoxContainer}>
                <Checkbox
                  color={commonColors.accentText}
                  uncheckedColor={commonColors.unchecked}
                  status={isChecked ? 'checked' : 'unchecked'}
                />
              </View>
            </View>
            <Divider style={{ marginVertical: 8 }} />
          </TouchableOpacity>
        )
      })}
      <BButton
        disabled={selectedReasons.length === 0 || false}
        buttonStyle={styles.dismissButton}
        onPress={dismiss}
      >
        {t('submit')}
      </BButton>
    </BuilderBottomModal>
  )
}

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkBoxContainer: {
    position: 'absolute',
    right: 0,
  },
  dismissButton: {
    marginTop: 40,
    width: '100%',
  },
})
